import React from "react";
import SalesDetails from "./sales";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";
// import SelectqstTable from './SelectqstTable';

const ChecklistData = () => {
  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col-md-12">
          <div className="checklist-section mb-3">
            <ErrorBoundary fallback={<ComponentViewFallback />}>
              <SalesDetails />
            </ErrorBoundary>
          </div>
        </div>
        <div className="col-md-12">
          <div className="checklist-section mb-3">
            {/* <SelectqstTable /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChecklistData;
